/* Переключатель «сетка / список». Режим — класс на <html> плюс localStorage.
   Адрес страницы не меняем: см. комментарий в ms4l-view-switch.css. 04.09.2026 */
(function () {
  var KEY = "ms4l_view";
  var root = document.documentElement;

  function saved() {
    try { return localStorage.getItem(KEY) === "list" ? "list" : "grid"; }
    catch (e) { return "grid"; }
  }
  function apply(mode) {
    root.classList.toggle("ms4l-view-list", mode === "list");
    var b = document.querySelectorAll("[data-ms4l-view]");
    for (var i = 0; i < b.length; i++) {
      b[i].setAttribute("aria-pressed", b[i].getAttribute("data-ms4l-view") === mode ? "true" : "false");
    }
  }

  /* Якорь #view=list / #view=grid открывает страницу сразу в нужном виде.
     Именно якорь, а не параметр: он не уходит на сервер и не делает из
     коллекции второй адрес, поэтому такой ссылкой можно делиться. */
  function fromHash() {
    var m = /(?:^|[#&])view=(list|grid)/.exec(location.hash || "");
    return m ? m[1] : null;
  }

  root.classList.add("ms4l-vs-ready");
  var start = fromHash();
  if (start) { try { localStorage.setItem(KEY, start); } catch (e) {} }
  apply(start || saved());

  document.addEventListener("click", function (e) {
    var t = e.target;
    var btn = t && t.closest ? t.closest("[data-ms4l-view]") : null;
    if (!btn) return;
    e.preventDefault();
    var m = btn.getAttribute("data-ms4l-view");
    try { localStorage.setItem(KEY, m); } catch (err) {}
    apply(m);
  });

  /* При смене фильтров Shopify перерисовывает секцию целиком — кнопки
     создаются заново и теряют состояние. Следим только за появлением
     узлов: атрибуты мы меняем сами, и наблюдение за ними зациклилось бы. */
  function watch() {
    var box = document.getElementById("ProductGridContainer");
    if (!box || !window.MutationObserver) return;
    new MutationObserver(function () { apply(saved()); })
      .observe(box, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", watch);
  else watch();
})();
